import { Chip as InternalChip } from "./chip";
import { Group } from "./chip.group";

type InternalChipType = typeof InternalChip;

type CompoundedComponent = InternalChipType & {
    Group: typeof Group;
};

export const Chip = InternalChip as CompoundedComponent;

Chip.Group = Group;

export { ChipProps, ChipGroupProps, OptionType } from "./chip.types";
